import type { JSX } from 'react';
import GlobalHeader from 'carbon-react/esm/components/global-header';
import Divider from 'carbon-react/esm/components/divider';
import Typography from 'carbon-react/esm/components/typography';

const Logo = () => <img src="/assets/sage-logo.svg" alt="Sage" width="40px" />;

const PublicNavbar = (): JSX.Element => {
  return (
    <GlobalHeader pr={2}>
      <Logo />
      <Divider pt={1} pb={1} pl={2} pr={0} height={24} />
      <Typography variant="h4" inverse pl={2} pt={1}>
        EDI Online
      </Typography>
    </GlobalHeader>
  );
};

export default PublicNavbar;
